import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import AboutContentEn from "./AboutContentEn";
import AboutContentFr from "./AboutContentFr";
import AboutContentAr from "./AboutContentAr";

function AuthAboutPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <UserNavBar />
      { lang ==='ar'
        ? <AboutContentAr />
        :lang === 'fr'
          ? <AboutContentFr /> 
          : <AboutContentEn />
      }
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default AuthAboutPage;
